module.exports = __webpack_public_path__ + "img/Copacabana.bfdf6b61.png";